import "./TechnicalDocumentation.module.css";
import Header from "@/reusable_sections/Header";
import SectionIndex from "./sections/SectionIndex";
import Specifications from "./sections/Specifications";
import Integration from "./sections/Integration";
import DataFormats from "./sections/DataFormats";
import Architecture from "./sections/Architecture";
import Footer from "@/reusable_sections/Footer";
export default function TechnicalDocumentationPage() {
  return <div>
      <Header />
      <div className="lg:flex lg:items-start">
        <SectionIndex />
        <div className="flex-1 min-w-0">
          <Specifications />
          <Integration />
          <DataFormats />
          <Architecture />
        </div>
      </div>
      <Footer />
    </div>;
}